import { Component, OnInit } from '@angular/core';
import { CommonComponent } from '../shared/common/common.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NotificationsService} from '../../services/notifications.service';
import {ToastaService} from 'ngx-toasta';
import {DialogService} from 'primeng/dynamicdialog';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {ActivatedRoute, ParamMap, Router} from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import {LocalStorageService} from "angular-2-local-storage";
import {StorageItem} from "../../enums/storage-item";

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.scss']
})
export class PasswordResetComponent extends CommonComponent implements OnInit {
  token: string;
  password: string;
  showPassword = false;
  showPasswordConfirm = false;
  passwordConfirmation: string;
  loadingService = false;
  submitting = false;
  reseted = false;
  passwordMinLength: boolean;
  passwordCapsLower: boolean;
  passwordNumber: boolean;
  passwordSpecial: boolean;
  passwordSpaces: boolean;
  passwordSequences: boolean;
  passwordRepetition: boolean;
  messages;
  messageError: string;
  messageInformation: string;
  passwordSuccess = false;
  password404 = false;
  passwordError = false;
  locale = this.route.snapshot.queryParamMap.get('locale');
  constructor(
    private authService: AuthenticationService,
    protected router: Router,
    protected modalService: NgbModal,
    protected notificationsService: NotificationsService,
    protected toastService: ToastaService,
    protected dialogService: DialogService,
    public translate: TranslateService,
    private route: ActivatedRoute,
    private localStorage: LocalStorageService
  ) {
    super(modalService, notificationsService, toastService, router, translate, dialogService);
    translate.addLangs(['es', 'en']);
    translate.setDefaultLang('es');
    translate.onLangChange.subscribe(
      (event: LangChangeEvent) => {
        if (this.passwordSuccess){
          this.messageInformation = this.messages.info = this.translate.instant('reset-password.success-update');
        }
        else if (this.password404) {
          this.messageError = this.translate.instant('reset-password.link-expired');
        }
        else if (this.passwordError) {
          this.messageError = this.translate.instant('reset-password.app-problems');
        }
      });
    if (this.locale === 'es' || this.locale === 'en'){
      translate.use(this.getValidLanguage(this.locale));
    }
  }
  ngOnInit(): void {
    this.route.paramMap.subscribe(
      (params: ParamMap) => {
        this.token = params.get('id');
      }
    );
  }

  passwordValidation() {
    if (this.password){
      this.passwordMinLength = this.password?.length >= 8 && this.password?.length <= 128;
      this.passwordCapsLower = this.passwordCapsValidation(this.password) && this.passwordLowerCaseValidation(this.password);
      this.passwordNumber = this.passwordNumberValidation(this.password);
      this.passwordSpecial = this.passwordSpecialValidation(this.password);
      this.passwordSequences = !this.passwordSequencesValidation(this.password);
      this.passwordRepetition = this.passwordRepetitionValidation(this.password);
      this.passwordSpaces = this.passwordSpacesValidation(this.password);
    }
  }
  resetPassword() {
    this.loadingService = true;
    this.submitting = true;
    this.authService.passwordReset(this.password, this.passwordConfirmation, this.token).subscribe(
      response => {
        this.submitting = false;
        this.reseted = true;
        this.passwordSuccess = true;
        this.messageInformation = this.translate.instant('reset-password.success-update', {Default: 'Tu contraseña se actualizó correctamente'});
        this.loadingService = false;
      }, error => {
        switch (error.status) {
          case 422:
            const err: any = error.error;
            let allMsgs = '';
            for (const item of err.errors) {
              allMsgs += `* ${item.defaultMessage} \n`;
            }
            this.messages = allMsgs.length > 0 ? allMsgs : err.error;
            break;
          case 404:
            this.password404 = true;
            this.messageError = this.translate.instant('reset-password.link-expired', {Default: 'La liga para cambio de contraseña ha expirado, favor de solicitarla de nuevo'});
            break;
          default:
            this.passwordError = true;
            this.messageError = this.translate.instant('reset-password.app-problems', {Default: 'Tenemos algunos problemas con la aplicación, por favor intenta mas tarde'});
            break;
        }
        this.submitting = false;
        this.loadingService = false;
      }
    );
  }
  passwordSequencesValidation(password: string) {
    if (password) {
      const textList = password.toLowerCase().split('');
      const alphabet = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
      const numerics = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
      let result = true;
      for (let i = 0; i < textList.length - 2; i++) {
        let num;
        let alp;
        alp = alphabet.find((element) => element === textList[i]);
        num = numerics.find((element) => element === textList[i]);

        let index;
        const next = textList[i + 1];

        if (alp) {
          index = alphabet.indexOf(alp);
          if (index <= alphabet.length - 3 && (next === (alphabet[index + 1]))) {
            if (textList[i + 2] === alphabet[index + 2]) {
              result = false;
              break;
            }
          }
          if (index >= 2 && (next === (alphabet[index - 1]))) {
            if (textList[i + 2] === alphabet[index - 2]) {
              result = false;
              break;
            }
          }
        }
        if (num) {
          index = numerics.indexOf(num);
          if (index <= numerics.length - 3 && (next === (numerics[index + 1]))) {
            if (textList[i + 2] === numerics[index + 2]) {
              result = false;
              break;
            }
          }
          if (index >= 2 && (next === (numerics[index - 1]))) {
            if (textList[i + 2] === numerics[index - 2]) {
              result = false;
              break;
            }
          }
        }
      }
      return result;
    }
    return false;
  }


  passwordRepetitionValidation(password: string) {
    password = password.toLowerCase();
    const passwordLetters = [];
    let reps = false;
    for (let i = 0; i < password.length; i++) {
      passwordLetters.push(password[i].charCodeAt(0));
      if (i > 1 ) {
        if ((passwordLetters[i - 2] === passwordLetters[i] && passwordLetters[i - 1] === passwordLetters[i])) {
          reps = true;
        }
      }
    }
    return reps;
  }
  passwordSpacesValidation(password: string) {
    const regex = new RegExp(/^\S*$/);
    return regex.test(password);
  }
  passwordCapsValidation(password: string) {
    const regex = new RegExp(/^(.*[A-Z].*)$/);
    return regex.test(password);
  }
  passwordLowerCaseValidation(password: string) {
    const regex = new RegExp(/^(.*[a-z].*)$/);
    return regex.test(password);
  }
  passwordNumberValidation(password: string) {
    const regex = new RegExp(/^(.*\d.*)$/);
    return regex.test(password);
  }
  passwordSpecialValidation(password: string) {
    const regex = new RegExp(/[^a-zA-Z0-9 ]/);
    return regex.test(password);
  }

  togglePasswordVisibility(type: 'password' | 'confirm'): void {
    if (type === 'password') {
      this.showPassword = !this.showPassword;
    } else if (type === 'confirm') {
      this.showPasswordConfirm = !this.showPasswordConfirm;
    }
  }

}
